<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Purchase Orders</h4>
                <p class="subtitle-1">List of purchase orders</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(perm.purchase_order.create)">
                <v-btn color="primary" block @click="handleNewOrder">
                    <v-icon left>mdi-plus</v-icon>
                    New Purchase Order
                </v-btn>
            </v-col>
            <v-col cols="12" md="3" >
                <v-menu offset-y :close-on-content-click="false" min-width="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            depressed
                            block
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <PurchaseOrderListSearch ref="form"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <PurcahseOrderList ref="list" :data="data"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PurchaseOrderListSearch from '../../components/purchase/PurchaseOrderListSearch.vue';
import PurcahseOrderList from '../../components/purchase/PurchaseOrderList.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "PurchaseOrderListView",
    components: {
        PurchaseOrderListSearch,
        PurcahseOrderList,
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            data: "purchase/order/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            search: "purchase/order/search"
        }),
        handleNewOrder() {
            this.$router.push({name: "PurchaseOrderCreate"})
        }
    },
    created() {
        
    }
}

</script>

<style>

</style>